// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.

/** Jargon → plain-English definitions, surfaced as click-to-define tooltips. */
export const GLOSSARY: Record<string, string> = {
  vector:
    'A vector image is made of shapes and curves described by maths, not a grid of pixels — so it stays sharp at any size.',
  raster:
    'A raster image is a grid of coloured pixels (PNG, JPG, photos). Zoom in far enough and you see the squares.',
  svg: 'Scalable Vector Graphics — the standard vector format for the web. A plain-text file of paths you can edit, recolour and resize losslessly.',
  potrace:
    'The open-source tracing engine Vectorwell runs (compiled to WebAssembly). It follows the boundaries in a bitmap and fits smooth curves to them.',
  path: 'One continuous shape in the SVG, written as a string of drawing commands. Fewer, cleaner paths mean a smaller, tidier file.',
  posterize:
    'Reducing an image to a small set of flat colours before tracing. More levels keep more colour detail; fewer give a bold, poster-like result.',
  speckle:
    'Tiny stray specks left by noise or JPEG artefacts. Raising speckle removal drops shapes smaller than the chosen size.',
  wasm: 'WebAssembly — a fast, low-level format that lets the C-based potrace engine run at near-native speed inside your browser tab.',
  'trace resolution':
    'The pixel size the image is traced at. Larger keeps more detail but makes a bigger SVG and takes longer; smaller is cleaner and faster.',
};
